import React, { Component } from 'react';

export default class CarsCheckbox extends Component {
	static findQuestionByMeta(questions, meta, value) {
		const question = questions.filter(qst => qst.meta[meta] === value);
		return question[0];
	}

	state = {
		values: [],
		openOption: '',
		checkable: true,
		disabled: false,
	};

	componentDidMount() {
		const { valueField } = this.props;
		if (valueField) {
			this.setState({
				openOption: valueField.openOption,
				values: valueField.values,
			});
		}
	}

	updateValues() {
		const {
			values,
			openOption,
		} = this.state;

		const { nameField, onChange } = this.props;

		const data = {
			values,
			openOption,
		};

		const e = {
			target: {
				name: nameField,
				value: data,
			},
		};

		onChange(e);
	}

	handleCheckClick(e) {
		const { values } = this.state;
		let { openOption } = this.state;

		const { meta } = this.props;

		let { maxInput } = this.props;

		if (meta.max_section) {
			maxInput = parseInt(meta.max_section, 10);
		}

		const element = e.target;

		if (element.checked) {
			values.push(element.value);
		} else {
			values.splice(values.indexOf(element.value), 1);
			if (element.name === 'open') {
				openOption = '';
				const prevState = this.state;
				this.setState({ ...prevState, openOption });
			}
		}

		this.setState({ disabled: false });

		if (values.length >= maxInput) {
			this.setState({ disabled: true });
		}

		this.setState({
			values,
			openOption,
		}, this.updateValues);
	}

	handleOpenOption(e) {
		const { values } = this.state;
		if (values.indexOf('open') === -1 && e.target.value.length > 0) {
			values.push('open');
		}

		const { prevState } = this.state;
		this.setState({
			...prevState,
			values,
			openOption: e.target.value,
		}, this.updateValues);
	}

	renderOptions() {
		const {
			options,
			nameField,
			valueField,
			// label,
		} = this.props;

		let parentValues = [];

		if (typeof valueField.values !== 'undefined') {
			parentValues = valueField.values;
		} else if (valueField.length > 0 && typeof valueField === 'string') {
			parentValues = JSON.parse(valueField).values;
		}

		return options.map((option) => {
			const {
				openOption,
				disabled,
				classContainer,
			} = this.state;

			if (option.editable) {
				return (
					<div className="form-check" key={option.value}>
						<label className="form-check-label container-option-field-text open" htmlFor={nameField + option.value}>
							<input
								className="form-check-input css-checkbox"
								type="checkbox"
								value="open"
								id={nameField + option.value}
								name="open"
								onChange={this.handleCheckClick.bind(this)}
								checked={(openOption.length > 0 || parentValues.indexOf('open') !== -1)}
								disabled={disabled && !(parentValues.indexOf('open') !== -1)}
							/>
							<i />
							<input className="field-text" type="text" value={openOption} onChange={this.handleOpenOption.bind(this)} placeholder={option.label} disabled={disabled && !(parentValues.indexOf('open') !== -1)} />
						</label>
					</div>
				);
			}

			return (
				<div className={`form-check ${classContainer}`} key={option.value}>
					<label className="form-check-label" htmlFor={nameField + option.value}>
						<input
							className="form-check-input css-checkbox"
							type="checkbox"
							value={option.value}
							id={nameField + option.value}
							name={nameField}
							onChange={this.handleCheckClick.bind(this)}
							checked={(parentValues.indexOf(option.value) !== -1)}
							disabled={disabled && !(parentValues.indexOf(option.value) !== -1)}
						/>
						<i />
						{option.label}
						{
							(typeof option.image !== 'undefined')
								? (
									<div className="checkbox-image">
										<img src={option.image} alt={option.label} />
									</div>
								)
								: ''
						}
					</label>
				</div>
			);
		});
	}

	render() {
		const {
			classContainer,
		} = this.props;

		return (
			<div className={`component-question-data ${classContainer}`}>
				<div className="checks-container">
					{ this.renderOptions() }
				</div>
			</div>
		);
	}
}
